import {Loader} from "@hosttools/frontend/components";

export default Loader;
